<template>
  <div>
    <div v-if="upgradeAvailable === true">
      <div class="content">
        <div class="w-full mt-5">
          <div class="card text-center">
            <div class="card__box mb-8 p-5 rounded">
              <div>
                <p class="text-grey">
                  Potrai continuare ad utilizzare la tua carta virtuale e in più
                  avrai a disposizione una carta fisica da usare in ogni momento.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="w-full">
          <img
            v-if="cardImage"
            class="card__box__img-influencer shadow-lg"
            style="max-width: 250px; width: 100%; margin: 20px auto;"
            :src="cardImage"
          />
          <p class="text-center f-b">
            Costo della carta:
            <span v-if="card.price === 0" :class="feePot ? 'card-old-price': ''">0,00€</span>
            <span v-else :class="feePot ? 'card-old-price': ''">{{ card.price | currency }}</span>
            <span v-if="feePot" class="card-promo-price"> 
                Power 
                <span v-if="card.price - feePot.availableAmount < 0">0,00€</span>
                <span v-else>{{card.price - feePot.availableAmount | currency}}</span>
            </span>
          </p>
        </div>

        <div class="w-full mt-5">
          <div class="card text-center">
            <div class="card__box mb-8 p-5 rounded">
              <div>
                <p class="text-grey">
                  Prendi visione e scarica il nuovo documento di sintesi. Dopo
                  aver scaricato il documento, ti consigliamo di salvare e
                  conservare il file.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="content flex flex-wrap">
          <div class="w-full mb-3">
            <div
              class="outline-link"
              :class="{ read: contract.read }"
              @click="
                () => {
                  openTerm(contract.termId);
                  contract.read = true;
                }
              "
            >
              <div class="outline-link__text">{{ contract.description }}</div>
              <div class="outline-link__status">
                {{ contract.read ? "Letto" : "Leggi per proseguire" }}
              </div>
            </div>
          </div>
        </div>
         <!-- POWER banner-->
         <div v-if="feePot === null && isMinor === false" class="mt-5">
            <PowerBanner />
          </div>
      </div>

      <div class="page-footer mt-10">
        <button class="btn" :disabled="!contract.read" @click="next">
          Prosegui
        </button>
      </div>
    </div>
    <div v-if="upgradeAvailable === false">
      <div class="content">
        <div class="w-full mt-5">
          <p class="f-b mb-2">Si è verificato un errore!</p>
          <p class="text-grey">
            L'upgrade è disponibile solo per chi è in possesso di carta virtuale
          </p>
        </div>
        <div class="page-footer mt-10">
          <button class="btn" @click="backToApp">
            Torna alla schermata iniziale
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UtilityService from "@/services/UtilityService";
import DocumentsService from "@/services/DocumentsService";
import WalletService from "@/services/WalletService";
import CrmService from "@/services/CrmService";
import ApiService from "@/services/ApiService";
import PowerBanner from "@/components/PowerBanner";

export default {
  name: "Upgrade",
  props: ["cardId"],
  components: {
    PowerBanner
  },

  data() {
    return {
      upgradeAvailable: undefined,
      card: {},
      cardImage: null,
      contract: {
        read: false,
        description: "Documento di sintesi",
        termId: 114
      },
      feePot: undefined
    };
  },
  computed: {
    appReady() {
      return this.$store.state.appReady;
    },
  },

  async mounted() {
     if (this.appReady) {
      this.init();
    } else {
      this.$root.$on(`storeUpdated@setAppReady`, state => {
        if (state.appReady) {
          this.init();
        }
      });
    }
  },
  methods: {
    async init() {
      this.$root.$emit("openGlobalLoader");
      try {
        const prepaidCards = await ApiService.get("/usr/v2/prepaid-cards");
        let cards = prepaidCards.data;

        //Remap for pairing virtual and physical cards
        cards.forEach(card => {
          if (card.relatedCardId) {
            cards.filter(c => c.id === card.relatedCardId)[0][
              "physicalCard"
            ] = card;
          }
        });

        const getCurrentCardWalletInstrument = await WalletService.getPrepaidCard();
        const getCurrentCardPan = await WalletService.getCardInfo(
          getCurrentCardWalletInstrument.id
        );
        const cardInfo = getCurrentCardPan.data;

        const isUpgradable = cardInfo.upgradableToPhysical;

        if (isUpgradable) {
          const cardModelUrl = cardInfo._links.prepaidCardModel.href;
          const getCurrentCardModel = await ApiService.get(cardModelUrl);
          const modelId = getCurrentCardModel.data.id;
          const card = cards.filter(c => c.id === modelId)[0];

          this.upgradeAvailable = true;
          this.card = card.physicalCard;
          this.cardImage = card.physicalCard.content?.imagesUrl?.front;
          this.feePot = await CrmService.getFeePot();
          this.isMinor = !!window.vm.$store.state.user.minor;
        } else {
          this.upgradeAvailable = false;
        }

        this.$root.$emit("closeGlobalLoader");
      } catch (error) {
        this.$root.$emit("closeGlobalLoader");
        UtilityService.showDefaultError(error);
      }
    },
    openTerm(id) {
      DocumentsService.openTerm(id);
    },
    next() {
      this.$root.$emit("submitStep");
    },
    backToApp(){
      UtilityService.backToInitialView();
    }
  }
};
</script>
<style lang="less" scoped>
.content {
  max-width: 500px;
  .card__box img {
    width: 100%;
    margin: 0 auto;
    max-width: 280px;
  }
  .pay-methods {
    display: flex;
    justify-content: space-around;
    div {
      width: 50px;
      height: 50px;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;

      &.applePay {
        background-image: url("../../assets/images/applePay_top.png");
      }
      &.samsungPay {
        background-image: url("../../assets/images/samsung_pay_badge.png");
      }
      &.garminPay {
        background-image: url("../../assets/images/garminPay_top.jpg");
      }
      &.googlePay {
        background-image: url("../../assets/images/googlePay_top.jpg");
      }
      &.fitbitPay {
        background-image: url("../../assets/images/fitbitPay_top.png");
      }
      &.swatchPay {
        background-image: url("../../assets/images/swatchPay.png");
      }

      //mobile sizes
      @media (max-width: 768px) {
        &.applePay {
          width: 56px;
        }

        &.garminPay {
          width: 82px;
        }
        &.googlePay {
          width: 64px;
        }
        &.fitbitPay {
          width: 93px;
        }
        &.swatchPay {
          width: 60px;
          margin-left: 10px;
        }
      }
    }
  }
}

.promo-label {
  background: #CC4B00;
  color: white;
  border-radius: 5px;
  font-size: 10px;
  text-align: center;
  display: inline-block;
  padding: 2px 5px;
}
.card-old-price {
  text-decoration: line-through;
  color: #9d9d9d;
  margin: 0 10px;
  font-size: 12px;
}
.card-promo-price {
  color: #CC4B00;
  font-size: 15px;
}
.card-promo-link {
  cursor: pointer;
  display: block;
  font-family: "Be Vietnam Pro Regular";
  color: #CC4B00;
  font-size: 11px;
  margin-top: 5px;
}
</style>
